module.exports = __webpack_public_path__ + "b29934c3671b908d2fcbfe74c757153d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/cabriolet.png
// module id = 392
// module chunks = 7